export default "__VITE_ASSET__BwKKFj6m__"